// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".quizScreen {\n    height: 100%;\n    /* height: 354px; */\n    width: 100%;\n    /* height: 100vh; */\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    /* height: calc(100vh - 63px); */\n    z-index: 10;\n    margin-top: auto;\n}", ""]);
// Exports
module.exports = exports;
